import { Routes } from '@angular/router';
import { LoginComponent } from './pages/auth/login/login.component';
import { CallbackComponent } from './pages/auth/callback/callback.component';
import { DocumentTemplateFormComponent } from './pages/document-template-form/document-template-form.component';
import { TemplateDetailComponent } from './pages/template-detail/template-detail.component';
import { authGuard } from './guards/auth.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { TemplatesComponent } from './pages/templates/templates.component';
import { OcrHistoryPageComponent } from './pages/ocr-history/ocr-history-page.component';
import { OcrDocumentViewerPageComponent } from './pages/ocr-document-viewer/ocr-document-viewer.component';
import { FieldsComponent } from './pages/fields/fields.component';
import { AnchorTreePageComponent } from './pages/anchor-tree/anchor-tree.component';
import { platformDataResolver } from './resolvers/platform-data.resolver';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'callback', component: CallbackComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    resolve: { platformData: platformDataResolver },
    children: [
      { path: '', redirectTo: 'ocr-history', pathMatch: 'full' },
      { path: 'templates', component: TemplatesComponent },
      { path: 'anchor-tree', component: AnchorTreePageComponent, canDeactivate: [unsavedChangesGuard] },
      { path: 'fields', component: FieldsComponent },
      { path: 'ocr-history', component: OcrHistoryPageComponent },
      { path: 'monitoring', loadComponent: () => import('./pages/monitoring/monitoring.component').then(m => m.MonitoringComponent) },
      { path: 'ocr-view', component: OcrDocumentViewerPageComponent },
      { path: 'ocr-view/:s3Key', component: OcrDocumentViewerPageComponent },
      { path: 'add-template', component: DocumentTemplateFormComponent, canDeactivate: [unsavedChangesGuard] },
      { path: 'edit-template/:id', component: DocumentTemplateFormComponent, canDeactivate: [unsavedChangesGuard] },
      { path: 'templates/:id', component: TemplateDetailComponent }
    ]
  },
  { path: '**', redirectTo: 'ocr-history' }
];
